import Grid from '@mui/material/Grid';
import { UseFormReturn } from 'react-hook-form';

import { TextFieldElement } from 'components/muiInputWrappers';

import { FormItem } from '../../shared/FormItem';
import { FormTitle } from '../../shared/FormTitle';
import { useTranslation } from 'react-i18next';

export type FormFields = {
  fromPercent?: number;
  toPercent?: number;
};

type Props = {
  form: UseFormReturn;
};

function FlagsSearchForm({ form }: Props) {
  const { t } = useTranslation('global');
  return (
    <Grid spacing={2} container>
      <Grid xs={12} item>
        <FormTitle gutterBottom>{t('common.commonProperties.from')}</FormTitle>
        <FormItem>
          <TextFieldElement
            control={form?.control}
            name="fromPercent"
            placeholder={t('common.commonProperties.from')}
            size="small"
            style={{ width: '100%' }}
            type="number"
            validation={{
              pattern: {
                value: /^[0-9,].*$/,
                message: t('ticket.messages.allowedValue')
              }
            }}
            variant="outlined"
          />
        </FormItem>
      </Grid>
      <Grid xs={12} item>
        <FormTitle gutterBottom>{t('common.commonProperties.to')}</FormTitle>
        <FormItem>
          <TextFieldElement
            control={form?.control}
            name="toPercent"
            placeholder={t('common.commonProperties.from')}
            size="small"
            style={{ width: '100%' }}
            type="number"
            validation={{
              pattern: {
                value: /^[0-9,].*$/,
                message: t('ticket.messages.allowedValue')
              }
            }}
            variant="outlined"
          />
        </FormItem>
      </Grid>
    </Grid>
  );
}

export default FlagsSearchForm;
